<template>
  <b-row>
    <b-col class="my-3">
      <b-row>
        <b-col>
          <b-badge class="bg-blue">
            <i class="fa fa-file mr-2"></i>
            Notice Of Variation In Partnership Terms
          </b-badge>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3" class="mt-1">
          <span class="text-sm">Variation Date</span>
          <b-form-input class="form-text"
                        :disabled="true" :value="dateFormat(data.variationDate)">
          </b-form-input>
        </b-col>
        <b-col cols="6">
          <span class="text-sm font-bold h6">New Terms</span>
          <p v-for="(term, idx) in data.terms" :key="idx" class="bg-header_grey border border-gray rounded-md px-2 py-2 mt-1 mb-2">
            {{term}}
          </p>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";

export default {
  name: "NoticeOfVariationInPartnershipTerms",
  props:{
    data:Object,
  },
  methods:{
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    cleanEntityType(name){
      let n = name.replaceAll("_", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
  },
};
</script>

<style scoped>

</style>